import { work_single_hero as initializeBlock } from '../../blocks/work-single-hero/index.js';

const runBlock = () => initializeBlock(document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runBlock, { once: true });
} else {
  runBlock();
}
